import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.codex.skills');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { CORE_CODEX_SKILL_GROUPS, CORE_CODEX_SKILLS, CoreCodexSkill, CoreCodexSkillGroup } from '../codex-skill-catalog';

@Component({
    selector: 'wiz-page-codex-skills',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.codex.skills/view.scss */
:host {
  display: block;
  min-height: 100vh;
  color: #202733;
  background: #f3f5f8;
  font-family: Inter, "Spoqa Han Sans Neo", "Apple SD Gothic Neo", "Noto Sans KR", sans-serif;
}

.codex-doc-shell {
  min-height: 100vh;
}

.codex-topbar {
  position: sticky;
  top: 0;
  z-index: 20;
  border-bottom: 1px solid #d9dee7;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(8px);
}

.codex-topbar__inner {
  width: min(1240px, 100% - 32px);
  min-height: 58px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.codex-brand {
  color: #147a3b;
  font-size: 18px;
  font-weight: 850;
  text-decoration: none;
}

.codex-nav {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: wrap;
}

.codex-nav a {
  padding: 7px 10px;
  border-radius: 6px;
  color: #475467;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
}

.codex-nav a:hover,
.codex-nav a:focus-visible {
  color: #166534;
  background: #e8f5ed;
  outline: none;
}

.codex-page {
  width: min(1240px, 100% - 32px);
  margin: 0 auto;
  padding: 22px 0 42px;
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  gap: 18px;
  align-items: start;
}

.codex-toc,
.codex-infobox {
  position: sticky;
  top: 80px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
}

.codex-toc {
  padding: 14px;
}

.codex-toc h2,
.codex-infobox h2 {
  margin: 0;
  color: #101828;
  font-size: 15px;
}

.codex-toc ol {
  margin: 10px 0 0;
  padding-left: 0;
  list-style: none;
  display: grid;
  gap: 6px;
}

.codex-toc a {
  color: #475467;
  font-size: 12px;
  line-height: 1.45;
  text-decoration: none;
}

.codex-toc a:hover,
.codex-toc a:focus-visible {
  color: #147a3b;
  text-decoration: underline;
  outline: none;
}

.codex-article {
  min-width: 0;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
}

.codex-title {
  padding: 28px 30px 22px;
  border-bottom: 1px solid #e4e8ef;
}

.codex-breadcrumb {
  margin: 0 0 8px;
  color: #147a3b;
  font-size: 12px;
  font-weight: 800;
}

.codex-title h1 {
  margin: 0;
  color: #111827;
  font-size: 36px;
  line-height: 1.2;
}

.codex-summary {
  max-width: 760px;
  margin: 14px 0 0;
  color: #475467;
  font-size: 15px;
  line-height: 1.75;
}

.codex-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 16px;
}

.codex-badges span {
  padding: 5px 8px;
  border: 1px solid #cfd7e3;
  border-radius: 6px;
  color: #344054;
  background: #f8fafc;
  font-size: 12px;
  font-weight: 750;
}

.codex-section {
  padding: 24px 30px;
  border-bottom: 1px solid #e4e8ef;
}

.codex-section:last-child {
  border-bottom: 0;
}

.codex-section h2 {
  margin: 0 0 14px;
  padding-bottom: 8px;
  border-bottom: 2px solid #d9dee7;
  color: #111827;
  font-size: 24px;
  line-height: 1.3;
}

.codex-section h3 {
  margin: 0 0 9px;
  color: #172033;
  font-size: 16px;
}

.section-number {
  margin-right: 8px;
  color: #147a3b;
  font-weight: 850;
}

.codex-section p {
  margin: 0 0 12px;
  color: #344054;
  font-size: 14px;
  line-height: 1.8;
}

.codex-section p code,
.codex-table code {
  padding: 2px 5px;
  border: 1px solid #d9dee7;
  border-radius: 5px;
  background: #f8fafc;
  color: #172033;
  font-size: 12px;
  overflow-wrap: anywhere;
}

.note-box {
  margin: 16px 0;
  padding: 14px 16px;
  border: 1px solid #bfd8ca;
  border-left: 4px solid #16a34a;
  border-radius: 8px;
  background: #f1fbf5;
}

.note-box strong {
  display: block;
  margin-bottom: 5px;
  color: #14532d;
  font-size: 13px;
}

.note-box p {
  margin: 0;
  color: #2f4f3a;
  font-size: 13px;
}

.codex-table {
  width: 100%;
  margin: 16px 0 6px;
  border-collapse: collapse;
  border: 1px solid #d9dee7;
  font-size: 13px;
}

.codex-table th,
.codex-table td {
  padding: 11px 12px;
  border: 1px solid #d9dee7;
  vertical-align: top;
  text-align: left;
}

.codex-table th {
  color: #172033;
  background: #f1f5f9;
  font-weight: 850;
}

.codex-table td {
  color: #475467;
}

.code-block {
  margin: 14px 0 4px;
  padding: 14px 16px;
  overflow-x: auto;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #111827;
  color: #e5e7eb;
  font-size: 13px;
  line-height: 1.6;
}

.case-summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin: 16px 0;
}

.case-summary > div {
  min-height: 78px;
  padding: 13px 14px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #fbfcfe;
}

.case-summary strong,
.case-summary span {
  display: block;
}

.case-summary strong {
  margin-bottom: 6px;
  color: #14532d;
  font-size: 12px;
  font-weight: 850;
}

.case-summary span {
  color: #475467;
  font-size: 13px;
  line-height: 1.55;
  overflow-wrap: anywhere;
}

.result-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin: 16px 0;
}

.result-card {
  display: flex;
  min-height: 100%;
  flex-direction: column;
  padding: 16px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #ffffff;
}

.result-card--goal {
  border-color: #a8d5ba;
  background: #f5fbf7;
}

.result-card--plain {
  border-color: #d7dde8;
  background: #f8fafc;
}

.result-card h3 {
  margin-bottom: 10px;
}

.result-card .related-links {
  flex: 1;
  padding-left: 17px;
  font-size: 13px;
}

.result-score {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid rgba(15, 23, 42, 0.1);
}

.result-score span {
  color: #667085;
  font-size: 12px;
  font-weight: 750;
}

.result-score strong {
  color: #14532d;
  font-size: 18px;
  font-weight: 900;
  white-space: nowrap;
}

.split-list,
.capture-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.split-list > div,
.capture-card {
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #fbfcfe;
}

.split-list > div {
  padding: 14px 16px;
}

.capture-card {
  overflow: hidden;
  margin: 0;
}

.capture-card img {
  display: block;
  width: 100%;
  height: auto;
}

.capture-card figcaption {
  padding: 10px 12px;
  border-top: 1px solid #d9dee7;
  color: #475467;
  font-size: 12px;
  font-weight: 800;
}

.related-links {
  margin: 0;
  padding-left: 18px;
  color: #344054;
  font-size: 14px;
  line-height: 1.75;
}

.related-links a {
  color: #166534;
  font-weight: 750;
  text-decoration: none;
}

.related-links a:hover,
.related-links a:focus-visible {
  text-decoration: underline;
  outline: none;
}

.codex-infobox {
  overflow: hidden;
}

.codex-infobox h2 {
  padding: 14px 16px;
  border-bottom: 1px solid #d9dee7;
  background: #e8f5ed;
  color: #14532d;
}

.codex-infobox dl {
  margin: 0;
}

.codex-infobox dl div {
  display: grid;
  grid-template-columns: 92px minmax(0, 1fr);
  border-bottom: 1px solid #e4e8ef;
}

.codex-infobox dt,
.codex-infobox dd {
  margin: 0;
  padding: 11px 12px;
  font-size: 12px;
  line-height: 1.5;
}

.codex-infobox dt {
  color: #344054;
  background: #f8fafc;
  font-weight: 850;
}

.codex-infobox dd {
  color: #475467;
}

.infobox-link {
  display: flex;
  justify-content: center;
  margin: 12px;
  min-height: 36px;
  align-items: center;
  border: 1px solid #cfd7e3;
  border-radius: 6px;
  color: #166534;
  background: #ffffff;
  font-size: 12px;
  font-weight: 800;
  text-decoration: none;
}

.infobox-link:hover,
.infobox-link:focus-visible {
  background: #f0fdf4;
  outline: none;
}

@media (max-width: 1080px) {
  .codex-page {
    grid-template-columns: 1fr;
  }
  .codex-toc {
    position: static;
  }
}
@media (max-width: 820px) {
  .codex-topbar__inner,
  .codex-page {
    width: min(100% - 24px, 1240px);
  }
  .codex-topbar__inner {
    min-height: auto;
    padding: 12px 0;
    align-items: flex-start;
    flex-direction: column;
  }
  .codex-page {
    grid-template-columns: 1fr;
    padding-top: 14px;
  }
  .codex-title,
  .codex-section {
    padding-left: 18px;
    padding-right: 18px;
  }
  .codex-title h1 {
    font-size: 30px;
  }
  .split-list,
  .capture-grid,
  .case-summary,
  .result-grid,
  .codex-infobox dl div {
    grid-template-columns: 1fr;
  }
}
.skill-group {
  margin-top: 18px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #fbfcfe;
  overflow: hidden;
}

.skill-group:first-of-type {
  margin-top: 0;
}

.skill-group__head {
  display: grid;
  grid-template-columns: 54px minmax(0, 1fr);
  gap: 14px;
  padding: 15px 16px;
  border-bottom: 1px solid #d9dee7;
  background: #f1f5f9;
}

.skill-group__head span {
  color: #147a3b;
  font-size: 13px;
  font-weight: 900;
  font-variant-numeric: tabular-nums;
}

.skill-group__head h3 {
  margin: 0;
}

.skill-group__head p {
  margin: 4px 0 0;
  font-size: 13px;
}

.skill-cards {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  padding: 14px;
}

.skill-entry {
  min-width: 0;
  display: flex;
  flex-direction: column;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  padding: 15px;
  background: #ffffff;
}

.skill-entry__top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
}

.skill-entry__top span,
.skill-entry__top strong {
  font-size: 12px;
  line-height: 1.4;
  font-weight: 850;
}

.skill-entry__top span {
  color: #166534;
}

.skill-entry__top strong {
  color: #475467;
}

.skill-entry h4 {
  margin: 8px 0 0;
  color: #111827;
  font-size: 19px;
  line-height: 1.35;
}

.skill-entry p {
  margin-top: 8px;
  font-size: 13px;
}

.skill-entry dl {
  flex: 1;
  margin: 12px 0 0;
  border-top: 1px solid #e4e8ef;
}

.skill-entry dl div {
  display: grid;
  grid-template-columns: 46px minmax(0, 1fr);
  gap: 10px;
  padding: 9px 0;
  border-bottom: 1px solid #eef2f6;
}

.skill-entry dt,
.skill-entry dd {
  margin: 0;
  font-size: 12px;
  line-height: 1.55;
}

.skill-entry dt {
  color: #172033;
  font-weight: 900;
}

.skill-entry dd {
  color: #475467;
}

.skill-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
}

.skill-tags span {
  border: 1px solid #d9dee7;
  border-radius: 6px;
  padding: 4px 6px;
  color: #475467;
  background: #f8fafc;
  font-size: 11px;
  font-weight: 750;
}

.skill-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.skill-link {
  display: inline-flex;
  flex: 1 1 150px;
  justify-content: center;
  align-items: center;
  min-height: 34px;
  border: 1px solid #b7d5c2;
  border-radius: 6px;
  color: #166534;
  background: #f4fbf6;
  font-size: 12px;
  font-weight: 850;
  text-decoration: none;
}

.skill-link--source {
  border-color: #cfd7e3;
  color: #344054;
  background: #f8fafc;
}

.skill-link:hover,
.skill-link:focus-visible {
  color: #ffffff;
  background: #166534;
  outline: none;
}

@media (max-width: 820px) {
  .skill-cards,
  .skill-group__head {
    grid-template-columns: 1fr;
  }
}`],
})
export class PageCodexSkillsComponent implements OnInit {
    public readonly skillGroups = CORE_CODEX_SKILL_GROUPS;
    public readonly skills = CORE_CODEX_SKILLS;

    constructor(@Inject( Service) public service: Service) { }

    public get detailedSkillCount(): number {
        return this.skills.filter((skill) => skill.status.includes('상세')).length;
    }

    public async ngOnInit() {
        await this.service.init();
    }

    public trackByGroup(_: number, group: CoreCodexSkillGroup) {
        return group.id;
    }

    public trackBySkill(_: number, skill: CoreCodexSkill) {
        return skill.id;
    }

    public trackByTag(_: number, tag: string) {
        return tag;
    }
}

export default PageCodexSkillsComponent;